<script lang="ts" setup>
import type {EventSimple} from "~/types/event";
import {formatInstanteToTimeBR, formatUsDateToBr} from "~/utils/datetime";

interface Props {
  event: EventSimple
}

const props = defineProps<Props>();
const event = computed<EventSimple>(() => props.event)

const place = computed<string>(() => {
  const addr = props.event.eventAddress;
  const str = `${addr?.place} - ${addr?.city} - ${addr?.state}`;
  return str.length > 60 ? str.substring(0, 60) + '...' : str
})

const name = computed(() => {
  const str = event.value.name
  if (!str) return str
  return str.length > 60 ? str.substring(0, 60) + '...' : str
})
</script>
<template>
  <div class="col">
    <div class="card shadow-sm card-hover border-0 h-100 mb-3">
      <div class="card-img-top card-img-hover">
        <nuxt-link class="img-overlay" :to="`/eventos/${event.slug}`" />
        <img :src="event.logo" :alt="event.name" class="main-card-img" />
      </div>
      <div class="card-body position-relative pb-4">
        <h4 class="mb-1 fs-xs fw-normal text-uppercase text-primary">{{event?.subCategory?.category?.description}}</h4>
        <h3 class="h6 mb-2 fs-base">
          <nuxt-link class="nav-link stretched-link" :to="`/eventos/${event.slug}`">
            {{ name }}
          </nuxt-link>
        </h3>
        <p class="mb-2 fs-sm text-muted">{{ place }}</p>
        <div class="fw-bold">
          <i class="fi-calendar mt-n1 me-2 lead align-middle opacity-70"></i>
          {{ formatUsDateToBr(event?.startAt) }} início às {{ formatInstanteToTimeBR(event?.startAt) }}
        </div>
      </div>
    </div>
  </div>
</template>
<style>
.main-card-img {
  width: 100%;
  margin: 0 auto;
  height: 200px;     /* Altura fixa desejada */
  object-fit: cover; /* Faz a imagem preencher o espaço sem distorcer */
  display: block;
}
@media (min-width: 768px) {
  .main-card-img {
    max-height: 250px;
  }
}
</style>
